import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'time_sleep',
  message0: '%{BKY_CUSTOM_TIME_SLEEP}',
  args0: [
    {
      type: 'input_value',
      name: 'SLEEP',
      check: 'Number'
    },
    {
      type: 'field_dropdown',
      name: 'TIME',
      options: [
        ['%{BKY_CUSTOM_TIME_SLEEP_SECOND}', 'sleep'],
        ['%{BKY_CUSTOM_TIME_SLEEP_MILLISECOND}', 'sleep_ms'],
        ['%{BKY_CUSTOM_TIME_SLEEP_MICROSECOND}', 'sleep_us']
      ]
    }
  ],
  previousStatement: null,
  nextStatement: null,
  style: 'loop_blocks',
  tooltip: '%{BKY_CUSTOM_TIME_SLEEP_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['time_sleep'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['time_sleep'] = function (block) {
  if (!block.disabled) Blockly.Python.definitions_.import_utime = 'import utime'
  let numberSleep = Blockly.Python.valueToCode(
    block,
    'SLEEP',
    Blockly.Python.ORDER_ATOMIC
  )
  numberSleep = numberSleep ? numberSleep : 0
  let dropdownTime = block.getFieldValue('TIME')
  let code = `utime.${dropdownTime}(${numberSleep})\n`
  return code
}
